import { Stack } from 'expo-router';
import { CardCredentialChallengeProvider } from 'features/cardManagement/providers/CardCredentialChallengeContext';
import React from 'react';

function CardLayout() {
  return (
    <CardCredentialChallengeProvider>
      <Stack screenOptions={{ headerShown: false }} />
    </CardCredentialChallengeProvider>
  );
}

export default CardLayout;
